/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface FormateurDesideratumSearch
 */
export interface FormateurDesideratumSearch {
    /**
     * 
     * @type {number}
     * @memberof FormateurDesideratumSearch
     */
    idFormateur?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurDesideratumSearch
     */
    centre?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurDesideratumSearch
     */
    anneeScolaire?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateurDesideratumSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateurDesideratumSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurDesideratumSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurDesideratumSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateurDesideratumSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurDesideratumSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateurDesideratumSearch interface.
 */
export function instanceOfFormateurDesideratumSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurDesideratumSearchFromJSON(json: any): FormateurDesideratumSearch {
    return FormateurDesideratumSearchFromJSONTyped(json, false);
}

export function FormateurDesideratumSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurDesideratumSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idFormateur': !exists(json, 'idFormateur') ? undefined : json['idFormateur'],
        'centre': !exists(json, 'centre') ? undefined : TextSearchFromJSON(json['centre']),
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : TextSearchFromJSON(json['anneeScolaire']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateurDesideratumSearchToJSON(value?: FormateurDesideratumSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idFormateur': value.idFormateur,
        'centre': TextSearchToJSON(value.centre),
        'anneeScolaire': TextSearchToJSON(value.anneeScolaire),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

